export function getDateCorrectedFormat(sqlDateString: string) {
    return new Date(sqlDateString).toLocaleDateString('he-IL')
}

export function getDateTimeCorrectedFormat(sqlDateString: string) {
    let dateTime = new Date(sqlDateString);
    return dateTime.toLocaleDateString('he-IL') + " " + dateTime.toLocaleTimeString('he-IL');
}

export function getTimeCorrectedFormat(sqlDateString: string) {
    let dateTime = new Date(sqlDateString);
    return dateTime.toLocaleTimeString('he-IL', {
        hour: '2-digit',
        minute: '2-digit'
    });
}

export function getTimeCorrectedFormatSLO(sqlDateString: string) {
    let dateTime = new Date(sqlDateString);
    return dateTime.toLocaleTimeString('he-IL', {
        hour: '2-digit',
        minute: '2-digit'
    }).replace(':', '.');
}

export function getAgoDate(date: Date, options?:IAgoDateOptions) {
    var second = 1000;
    var minute = second * 60;
    var hour = minute * 60;
    var day = hour * 24;
    var month = day * 31;
    var year = day * 365;

    if(!options)
        options = getEngAgoDateOptions();

    var dateDiff = new Date().getTime() - new Date(date).getTime();

    var diff: number;
    var option: IAgoDateOption;

    if(dateDiff > year){
        var diff = Math.trunc(dateDiff / year);        
        option = findOption(options.years, diff);
    }
    else if(dateDiff > month){
        var diff = Math.trunc(dateDiff / month);        
        option = findOption(options.months, diff);
    }
    else if(dateDiff > day){
        var diff = Math.trunc(dateDiff / day);        
        option = findOption(options.days, diff);
    }
    else if(dateDiff > hour){
        var diff = Math.trunc(dateDiff / hour);        
        option = findOption(options.hours, diff);
    }
    else if(dateDiff > minute){
        var diff = Math.trunc(dateDiff / minute);        
        option = findOption(options.minutes, diff);
    }
    else{
        var diff = Math.trunc(dateDiff / second);        
        option = findOption(options.minutes, diff);
    }
    return diff + " " + option.label
}

function findOption(options: IAgoDateOption[], value: number): IAgoDateOption{
    var option = options.filter(option => option.maxValue && option.maxValue >= value).sort((a, b) => b.maxValue! - a.maxValue!)[0];
    if(!option)
        option = options.find(option => option.maxValue == null)!;
    
    return option
}

interface IAgoDateOptions{
    seconds: IAgoDateOption[];
    minutes: IAgoDateOption[];
    hours: IAgoDateOption[];
    days: IAgoDateOption[];
    months: IAgoDateOption[];
    years: IAgoDateOption[];
}
function getEngAgoDateOptions(): IAgoDateOptions{
    return {
        seconds:[{
            maxValue: 1,
            label: "second"
        },
        {
            label: "seconds"
        }],
        minutes:[{
            maxValue: 1,
            label: "minute"
        },
        {
            label: "minutes"
        }],
        hours:[{
            maxValue: 1,
            label: "hour"
        },
        {
            label: "hours"
        }],
        days:[{
            maxValue: 1,
            label: "day"
        },
        {
            label: "days"
        }],
        months:[{
            maxValue: 1,
            label: "month"
        },
        {
            label: "months"
        }],
        years:[{
            maxValue: 1,
            label: "year"
        },
        {
            label: "years"
        }]
    }
}

interface IAgoDateOption{
    maxValue?: number;
    label: string;
}